import team1 from "../../Images/team-1.png";
import team2 from "../../Images/team-2.png";
import team3 from "../../Images/team-3.png";
import team4 from "../../Images/team-4.png";
import {
    FaTwitter,
    FaFacebookF,
    FaLinkedinIn,
    FaInstagram,
  } from "react-icons/fa";


export const TeamData = [
    {
        name : "Hackson Willi",
        title : "CEO and Founder",
        img : team1,
        social : [
            {
                icon : <FaFacebookF/>,
                path : ""
            },
            {
                icon : <FaTwitter/>,
                path : ""
            },
            {
                icon : <FaLinkedinIn/>,
                path : ""
            },
            {
                icon : <FaInstagram/>,
                path : ""
            },
        ]
    },
    {
        name : "Alexa Boss",
        title : "Project Manager",
        img : team2,
        social : [
            {
                icon : <FaFacebookF/>,
                path : ""
            },
            {
                icon : <FaTwitter/>,
                path : ""
            },
            {
                icon : <FaLinkedinIn/>,
                path : ""
            },
            {
                icon : <FaInstagram/>,
                path : ""
            },
        ]
    },
    {
        name : "Adam Spears",
        title : "Techician",
        img : team3,
        social : [
            {
                icon : <FaFacebookF/>,
                path : ""
            },
            {
                icon : <FaTwitter/>,
                path : ""
            },
            {
                icon : <FaLinkedinIn/>,
                path : ""
            },
            {
                icon : <FaInstagram/>,
                path : ""
            },
        ]
    },
    {
        name : "Diana Watson",
        title : "Marketing Manager",
        img : team4,
        social : [
            {
                icon : <FaFacebookF/>,
                path : ""
            },
            {
                icon : <FaTwitter/>,
                path : ""
            },
            {
                icon : <FaLinkedinIn/>,
                path : ""
            },
            {
                icon : <FaInstagram/>,
                path : ""
            },
        ]
    },
]